import { CreateTagDto, DeleteTagDto, ITag, TagFilterDto } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class TagApi {
  static getTags(filter?: TagFilterDto): Promise<AxiosResponse<ITag[]>> {
    return AdmiralApi.apiCall<ITag[]>({
      method: 'POST',
      url: `${BASE_URL}/tag/list`,
      data: filter,
    });
  }

  // static update(updateTaskDto: UpdateTaskDto): Promise<AxiosResponse<ITask>> {
  //   return AdmiralApi.apiCall<ITask>({
  //     method: 'PUT',
  //     url: `${BASE_URL}/task/update`,
  //     data: updateTaskDto,
  //   });
  // }
  static create(createTagDto: CreateTagDto): Promise<AxiosResponse<ITag>> {
    return AdmiralApi.apiCall<ITag>({
      method: 'POST',
      url: `${BASE_URL}/tag/create`,
      data: createTagDto,
    });
  }
  //
  static delete(deleteTagDto: DeleteTagDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/tag`,
      data: deleteTagDto,
    });
  }
}
